// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"18":"bd5cb50d","50":"f62a3de4","93":"f273a3fd","633":"df78aaa3","881":"869ec74f","965":"c9a2c8fd"}[chunkId] + ".css";
};